import "./attention-banner.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useDispatch, useSelector } from "react-redux";

import { getIsAlertVisibility, setIsAlertVisibility, setCloseAttentionBanner } from "features/authSlice";
import useDesktopChecker from "hooks/useDesktopChecker";

const AttentionBanner = () => {
  const isDesktop = useDesktopChecker();
  const dispatch = useDispatch();
  const isAlertVisible = useSelector(getIsAlertVisibility);
  const handleDismiss = () => {
    dispatch(setIsAlertVisibility(false));
    dispatch(setCloseAttentionBanner(true));
  };

  if (!isAlertVisible) return null;
  if (isDesktop) {
    return (
      <div className="attention-banner">
        <FontAwesomeIcon className="attention-icon" icon={solid("triangle-exclamation")} />
        <span className="attention-text">You have new comments regarding your tasks that need attention.</span>
        <FontAwesomeIcon icon={solid("xmark")} className="attention-close-icon" onClick={handleDismiss} />
      </div>
    );
  }

  return (
    <div className="attention-banner">
      <FontAwesomeIcon className="attention-icon" icon={solid("triangle-exclamation")} />
      <span className="attention-text">You have new comments regarding your tasks that need attention</span>
      <FontAwesomeIcon icon={solid("xmark")} className="attention-close-icon" onClick={handleDismiss} />
    </div>
  );
};

export default AttentionBanner;
